import { Skelton } from 'library/skelton';
import { FC } from 'react';

interface ImageSliderSkeltonProps {
    count?: number;
}

const ImageSliderSkelton: FC<ImageSliderSkeltonProps> = (props) => {
    const { count = 6 } = props;

    return (
        <div className="flex items-center gap-5">
            {Array.from(Array(count).keys()).map((r, i) => (
                <div key={r} className="p-[6px] pb-1 bg-card-color rounded-2xl border-2 border-card-color">
                    <Skelton variant="rectangular" width="80px" height="64px" />

                    <div className="text-sm mt-2">
                        <Skelton width="48px" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ImageSliderSkelton;
